import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/Card';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';
interface TrendChartProps {
  title: string;
  description?: string;
  data: any[];
  metrics: {
    key: string;
    name: string;
    color: string;
    type?: 'line' | 'bar';
  }[];
  height?: number;
}
export function TrendChart({
  title,
  description,
  data,
  metrics,
  height = 350
}: TrendChartProps) {
  return <Card className="flex flex-col h-full" data-id="element-111">
      <CardHeader data-id="element-112">
        <CardTitle data-id="element-113">{title}</CardTitle>
        {description && <CardDescription data-id="element-114">{description}</CardDescription>}
      </CardHeader>
      <div className="flex-1 min-h-[300px]" style={{
      height
    }} data-id="element-115">
        <ResponsiveContainer width="100%" height="100%" data-id="element-116">
          <ComposedChart data={data} margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0
        }} data-id="element-117">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-118" />
            <XAxis dataKey="date" tick={{
            fontSize: 12,
            fill: '#64748b'
          }} axisLine={false} tickLine={false} minTickGap={30} data-id="element-119" />
            <YAxis tick={{
            fontSize: 12,
            fill: '#64748b'
          }} axisLine={false} tickLine={false} data-id="element-120" />
            <Tooltip contentStyle={{
            backgroundColor: '#fff',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
          }} itemStyle={{
            fontSize: '12px'
          }} labelStyle={{
            fontSize: '12px',
            fontWeight: 'bold',
            color: '#1e293b',
            marginBottom: '8px'
          }} data-id="element-121" />
            <Legend wrapperStyle={{
            paddingTop: '20px'
          }} data-id="element-122" />
            {metrics.map(metric => metric.type === 'bar' ? <Bar key={metric.key} dataKey={metric.key} name={metric.name} fill={metric.color} radius={[4, 4, 0, 0]} barSize={20} data-id="element-123" /> : <Line key={metric.key} type="monotone" dataKey={metric.key} name={metric.name} stroke={metric.color} strokeWidth={2} dot={false} activeDot={{
            r: 6
          }} data-id="element-124" />)}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Card>;
}